import CardClass from "../../CardClass";
import Table from "../../Table";
import Menu from "../../Menu";
import Progress from "../../Progress";
import MUIButton from "@mui/material/Button";
import MUILoadingButton from "@mui/lab/LoadingButton";
import MUIListItemIcon from "@mui/material/ListItemIcon";
import MUIMergeIcon from "@mui/icons-material/Merge";
import MUIMenuItem from "@mui/material/MenuItem";
import DialogConfirmPatientMerge from "../../Dialog/DialogConfirmPatientMerge";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
import OrderService from "../../../Seating/Security/OrderService/orderService";
import Security from "../../../Utility/Security";

export default class CardPatientSearchResults extends CardClass {
  constructor(props) {
    super(props);

    this.state = {
      mergeEditorOn: false,
      dialogConfirmPatientMergeOpen: false,
      loading: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.rows) !== JSON.stringify(this.props.rows)) {
      this.setState({
        mergeEditorOn: false,
        selectedRows: {},
      });
    }
  }

  /**
   * Render the content of the card.
   */
  renderContent() {
    const handleClick = (row) => {
      const selectedRows = { ...this.state.selectedRows };
      if (selectedRows[row.id] === true) {
        delete selectedRows[row.id];
      } else {
        selectedRows[row.id] = true;
      }

      this.setState({
        selectedRows: selectedRows,
      });
    };

    const handleRadioChange = (e) => {
      this.setState({
        selectedMasterRecord: e.target.value,
      });
    };

    const handlePatientMerge = () => {
      const selectedRows = { ...this.state.selectedRows };

      delete selectedRows[this.state.selectedMasterRecord];

      const params = {
        masterId: this.state.selectedMasterRecord.toString(),
        ids: Object.keys(selectedRows).toString(),
      };

      this.setState({ loading: true });

      OrderService.mergePatients(params)
        .then(() => {
          this.props.onConfirm();
          NotistackEnqueueSnackbar("Patients merged successfully", {
            variant: "success",
          });
        })
        .catch((error) => {
          NotistackEnqueueSnackbar("Error merging patients", {
            variant: "error",
          });
        });

      this.setState({
        dialogConfirmPatientMergeOpen: false,
        selectedRows: {},
        selectedMasterRecord: null,
        loading: false,
        mergeEditorOn: false,
      });
    };

    const selectedRowsData = this.props.rows.filter(
      (row) => this.state.selectedRows && this.state.selectedRows[row.id],
    );

    if (this.props.loading) {
      return <Progress message={"Loading..."} />;
    }

    return (
      <>
        <Table
          search={true}
          checkbox={this.state.mergeEditorOn ? true : false}
          columns={[
            {
              key: "patient",
              name: "Patient Name",
              type: "string",
              width: "280px",
            },
            {
              key: "isPediatric",
              name: "",
              type: "boolean",
              icon: "ChildCare",
              color: (theme) => theme.palette.info.light,
              width: "80px",
            },
            { key: "id", name: "ID", type: "number", width: "150px" },
            {
              key: "dateOfBirth",
              name: "DOB",
              type: "localDate",
              width: "150px",
            },
            { key: "phone", name: "Phone #", type: "number", width: "220px" },
            { key: "address", name: "Address", type: "string" },
            {
              key: "id",
              name: "",
              type: "iconButton",
              icon: "OpenInNew",
              color: "primary",
              width: "80px",
            },
          ]}
          rows={this.props.rows}
          onClick={(row) => {
            if (this.state.mergeEditorOn) {
              handleClick(row);
            } else {
              this.props.history.push(`/chart/${row.id}`);
            }
          }}
          selectedRows={this.state.selectedRows}
        />
        <DialogConfirmPatientMerge
          open={this.state.dialogConfirmPatientMergeOpen}
          onClose={() =>
            this.setState({
              dialogConfirmPatientMergeOpen: false,
              selectedMasterRecord: null,
            })
          }
          onChange={handleRadioChange}
          onConfirm={handlePatientMerge}
          selectedRowsData={selectedRowsData || []}
          selectedRows={
            this.state.selectedRows ? Object.keys(this.state.selectedRows) : []
          }
          selectedMasterRecord={this.state.selectedMasterRecord}
          loading={this.state.loading}
        />
      </>
    );
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "Results";
  }

  /**
   * Renders actions menu.
   */
  getActions() {
    if (Security.hasPermission("patient.mergePatients")) {
      if (this.state.mergeEditorOn) {
        return [
          <MUIButton
            key="cancel-merge"
            variant="text"
            onClick={() => {
              this.setState({
                mergeEditorOn: false,
                selectedRows: {},
                selectedMasterRecord: null,
              });
              this.props.onConfirm();
            }}
          >
            Cancel
          </MUIButton>,
          <MUILoadingButton
            key="complete-merge"
            loading={this.state.loading}
            disabled={
              !this.state.selectedRows ||
              (this.state.selectedRows &&
                Object.keys(this.state.selectedRows).length < 2)
            }
            component="label"
            variant="contained"
            onClick={() => {
              this.setState({
                dialogConfirmPatientMergeOpen: true,
              });
            }}
          >
            Begin Merge
          </MUILoadingButton>,
        ];
      } else {
        return [
          <Menu
            key="merge-menu"
            menuItems={[
              <MUIMenuItem
                key="merge-patients"
                disabled={
                  this.props.loading ||
                  (this.props.rows && this.props.rows.length < 2)
                }
                onClick={() => this.setState({ mergeEditorOn: true })}
              >
                <MUIListItemIcon>
                  <MUIMergeIcon fontSize="small" />
                </MUIListItemIcon>
                Merge Patients
              </MUIMenuItem>,
            ]}
          />,
        ];
      }
    }

    return [];
  }
}
